import { createNonUndoableAction } from '../designer/workflow-designer/utils/action-utils';
import { props } from '@ngrx/store';
export const REDUCER_TYPE = '[Empowerment]';
export const ACTION_PAGE_DATA_LOADED = REDUCER_TYPE + ' Data Loaded';

export const updateCurrentPageData = createNonUndoableAction(ACTION_PAGE_DATA_LOADED, props<{ pageData: object }>());
